import { DataGridProProps } from "@mui/x-data-grid-pro";
import { Product } from "entities/products/types";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_GREY_8 } from "shared/theme/colors";
import { SettingsIcon } from "shared/theme/icons/Settings";

type ProductsColumnsProps = {
  handleAction: (params: Product) => void;
};

export const studioProductsColumns = ({
  handleAction,
}: ProductsColumnsProps): DataGridProProps["columns"] => [
  {
    field: "id",
    headerName: "ID",
    editable: false,
    flex: 1,
    sortable: false,
  },
  {
    field: "name",
    headerName: "Name",
    editable: false,
    flex: 1,
  },
  {
    field: "actions",
    headerName: "",
    editable: false,
    sortable: false,
    flex: 0.25,
    renderCell: (params) => {
      return (
        <FlexCenter onClick={() => handleAction(params.row)}>
          <SettingsIcon color={COLOR_GREY_8} />
        </FlexCenter>
      );
    },
  },
];
